import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {Tile} from '../../../../../shared/models/tile';
import {EMPTY_ID} from '../../../../../shared/constants/empty-id';
import {Observable, Subject, Subscription} from 'rxjs';
import {FindAndReplace} from '../bulk-clone-tiles.component';
import {SimpleStructure} from '../../../../../shared/models/structure';
import {PillComponent} from '../../../pill/pill.component';
import {PointDefinitionPillComponent} from '../../../point-definition-pill/point-definition-pill.component';
import {FormsModule} from '@angular/forms';
import {escapeRegExp} from '../../../../../shared/utils/string-utils';

@Component({
  selector: 'motn-bulk-clone-tile-row',
  templateUrl: './bulk-clone-tile-row.component.html',
  styleUrls: ['./bulk-clone-tile-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PillComponent,
    PointDefinitionPillComponent,
    FormsModule,
  ],
})
export class BulkCloneTileRowComponent implements OnInit, OnDestroy {

  @Input() original: Tile;
  clone: Tile;

  @Input() findAndReplace$: Observable<FindAndReplace>;
  private findAndReplaceSub: Subscription;

  @Input() cloningActive$: Subject<boolean>;
  cloningActive: boolean;
  private cloningActiveSub: Subscription;

  @Output() clone$: EventEmitter<Tile> = new EventEmitter<Tile>();


  constructor() {
  }


  ngOnInit(): void {
    this.clone = Tile.create(this.original);
    this.clone.ID = EMPTY_ID;
    this.emitUpdate();

    this.findAndReplaceSub = this.findAndReplace$.subscribe({
      next: (data) => {
        const escapedFind = escapeRegExp(data.find);
        const find = new RegExp(escapedFind, 'g');
        this.clone.Name = this.clone.Name.replace(find, data.replace);
      },
    });

    this.cloningActiveSub = this.cloningActive$.subscribe({
      next: (active) => {
        this.cloningActive = active;
      },
    });
  }


  ngOnDestroy() {
    this.findAndReplaceSub?.unsubscribe();
    this.cloningActiveSub?.unsubscribe();
  }


  getOriginalTileStructure(): SimpleStructure {
    return this.original.Structure as SimpleStructure;
  }


  emitUpdate() {
    this.clone$.emit(this.clone);
  }
}
